module.exports = __webpack_public_path__ + "static/media/home_3.b94c7f4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage_new/images/home/home_3.png
// module id = 2694
// module chunks = 0